import styled from "styled-components";
import { Paper } from "@mui/material";
import { theme } from "styles/mui-config";

export const StyledPaper = styled(Paper)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 90px;
`;
////////////////////////////////////////
export const StyledCountDiv = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.edit ? "green" : "#ff2424"};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  cursor:pointer;
  float:left;
  margin-right:15px;
`;
